export function getProcessorsWithQueues(processors, connections) {
  const processorsWithQueues = [];

  processors.forEach((processor) => {
    const incomingConnections = connections.filter(
      (conn) => conn.component?.destination?.id === processor.id
    );

    const totalQueuedItems = incomingConnections.reduce((total, conn) => {
      const queuedCount = parseInt(conn.status?.aggregateSnapshot?.queuedCount || 0, 10);
      return total + queuedCount;
    }, 0);

    if (totalQueuedItems > 1) {
      processorsWithQueues.push({
        processor,
        totalQueuedItems,
        incomingConnections,
      });
    }
  });

  return processorsWithQueues;
}

export function getBusyLevel(queuedCount) {
  if (queuedCount >= 10000) return 'critical';
  if (queuedCount >= 1000) return 'high';
  if (queuedCount >= 100) return 'medium';
  if (queuedCount > 0) return 'low';
  return 'none';
}
